/*!
 * Quick Cart Timer
 * Standalone init script. Loaded once at page render via {{ ... | script_tag }}
 * inside sections/quick-cart.liquid. Survives the cart-drawer AJAX refresh
 * (which uses innerHTML and would otherwise neuter any inline <script> tags
 * that live inside the cart drawer).
 */
(function () {
  'use strict';

  function pad(n) { return String(n).padStart(2, '0'); }

  function computeTarget(cfg) {
    var now = Date.now();
    if (cfg.mode === 'fixed_date') {
      var tz = cfg.timeZoneSelection === 'shop' && cfg.shopTimezone
        ? ' GMT' + cfg.shopTimezone : '';
      var parsed = Date.parse(
        cfg.endMonth + ' ' + cfg.endDay + ', ' + cfg.endYear + ' ' +
        cfg.endHour + ':' + pad(cfg.endMinute) + tz
      );
      return isNaN(parsed) ? now : parsed;
    }
    if (cfg.mode === 'urgency') {
      var key = cfg.storageKey;
      var start = null;
      try {
        var raw = sessionStorage.getItem(key);
        if (raw) {
          var v = parseInt(raw, 10);
          if (!isNaN(v)) start = v;
        }
      } catch (e) {}
      // If the saved start is already older than the configured window,
      // discard it so the visitor gets a fresh urgency window on the next
      // page load instead of being stuck at 00:00.
      if (start && (now - start) >= (cfg.urgencyMinutes * 60 * 1000)) {
        start = null;
        try { sessionStorage.removeItem(key); } catch (e) {}
      }
      if (!start) {
        start = now;
        try { sessionStorage.setItem(key, String(start)); } catch (e) {}
      }
      return start + (cfg.urgencyMinutes * 60 * 1000);
    }
    if (cfg.mode === 'daily') {
      var target = new Date();
      target.setHours(cfg.dailyHour, cfg.dailyMinute, 0, 0);
      if (target.getTime() <= now) {
        target.setDate(target.getDate() + 1);
      }
      return target.getTime();
    }
    return now;
  }

  function initOne(el) {
    if (el.__qctInit) return;
    el.__qctInit = true;

    var configEl = el.querySelector('[data-qct-config]');
    if (!configEl) return;
    var cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }

    var daysEl  = el.querySelector('[data-qct-days]');
    var hoursEl = el.querySelector('[data-qct-hours]');
    var minsEl  = el.querySelector('[data-qct-minutes]');
    var secsEl  = el.querySelector('[data-qct-seconds]');
    var clockEl = el.querySelector('[data-qct-clock]');
    var endEl   = el.querySelector('[data-qct-end]');

    var endTime = computeTarget(cfg);
    var interval = null;

    function tick() {
      var now = Date.now();
      var dist = endTime - now;

      if (dist <= 0) {
        if (cfg.mode === 'daily') {
          endTime = computeTarget(cfg);
          dist = endTime - now;
          if (dist <= 0) return;
        } else {
          if (interval) { clearInterval(interval); interval = null; }
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minsEl.textContent  = '00';
          secsEl.textContent  = '00';
          el.classList.add('qct-complete');
          if (clockEl) clockEl.hidden = true;
          if (endEl) endEl.hidden = false;
          if (cfg.hideOnComplete && !endEl) {
            el.classList.add('qct-hidden');
          }
          return;
        }
      }

      var days    = Math.floor(dist / 86400000);
      var hours   = Math.floor((dist % 86400000) / 3600000);
      var minutes = Math.floor((dist % 3600000) / 60000);
      var seconds = Math.floor((dist % 60000) / 1000);

      el.classList.toggle('qct-no-days', days === 0);

      daysEl.textContent  = pad(days);
      hoursEl.textContent = pad(hours);
      minsEl.textContent  = pad(minutes);
      secsEl.textContent  = pad(seconds);
    }

    tick();
    interval = setInterval(tick, 1000);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-quick-cart-timer]');
    for (var i = 0; i < nodes.length; i++) initOne(nodes[i]);
  }

  // ---------- Boot + re-init hooks ----------

  function boot() {
    initAll();

    // Re-init whenever the theme re-renders the cart drawer via AJAX.
    // The quick-cart section file dispatches 'quick-cart:rendered' on document
    // at the end of refreshQuickCart(). 'shopify:section:load' covers the
    // theme editor.
    document.addEventListener('quick-cart:rendered', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

    // MutationObserver safety net: if any code path replaces the cart
    // drawer's innerHTML without firing 'quick-cart:rendered', the
    // observer will still catch the new timer node and initialize it.
    // Filtered to only run when a [data-quick-cart-timer] is actually
    // added — so per-second textContent updates do NOT re-trigger init.
    var cartRoot = document.querySelector('.quick-cart');
    if (cartRoot && window.MutationObserver) {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            var isTimer = node.matches && node.matches('[data-quick-cart-timer]');
            var hasTimer = node.querySelector && node.querySelector('[data-quick-cart-timer]');
            if (isTimer || hasTimer) {
              initAll(cartRoot);
              return;
            }
          }
        }
      });
      mo.observe(cartRoot, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
